import React from 'react'
import { useParams } from 'react-router-dom'
import {  useSelector } from 'react-redux'
import { selectUserById } from './usersApiSlice'
import EditUserForm from './EditUserForm'
import { useGetUsersQuery } from './usersApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'

const EditUser = () => {
    const {id} = useParams()
    const {user} = useGetUsersQuery('usersList',{
        selectFromResult: ({data}) => ({
          user: data?.entities[id]
        }),
    })
    // useParams returns an object of key/value pairs of the dynamic params from the current URL that were matched by the routes.
    // const user = useSelector(state => selectUserById(state,id))

    if(!user) return <PulseLoader color={"#FFF"} />
    const content = <EditUserForm user= {user}/>
    // const content = user ? <EditUserForm user={user} /> : <p>Loading...</p>

  return content
}

export default EditUser